export default "__VITE_ASSET__DE61wnjJ__"